import React, {Component} from 'react';
import {Button, Drawer, Icon, Row, Col, Spin, Pagination} from 'antd';
import {app, api} from '../../app';
import IUpload from './IUpload';
import {getInsuranceOrderLists, insuranceOrderCancel, insuraOrderPay} from './insure_api';
import {getInsuranceOrgInvoice, getInsuranceOrgOrderPay} from './insure_org_api';
import utils from '../../utils';

class IOrderList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data_loading: true,
      pay_loading: false,
      dataList: [],
      page: 1,
      total: 0
    };
  }

  async componentDidMount() {
    this._isMounted = true;
    await this.dataSource(1);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setData = (data) => app.setStateSync(this, data);

  /**
   * 数据列表
   * @param page
   * @returns {Promise<void>}
   */
  dataSource = async (page) => {
    const state = {data_loading: true, dataList: []};
    if (page) {
      state.page = page;
    } else {
      page = this.state.page;
    }
    await this.setData(state);
    const {data, total} = await getInsuranceOrderLists(page);
    if (page === this.state.page) {
      await this.setData({
        total,
        dataList: utils.addArrayKey(data),
        data_loading: false,
      });
    }
  };

  /**
   * 取消订单
   * @param id
   * @returns {Promise<void>}
   */
  handleOrderCancel = async (id) => {
    app.alert('正在取消...', 'loading', '45%', 0);
    const flag = await insuranceOrderCancel(id);
    app.alertDestroy();
    if (flag) {
      app.alert('取消成功', 'success');
      await this.dataSource(1);
    }
  };

  /**
   * 支付订单
   * @param id
   * @param type
   * @returns {Promise<void>}
   */
  handleOrderPay = async (id, type) => {
    if (this.state.pay_loading) {
      app.alert('有订单正在加载支付，请稍等', 'warn');
    }
    await this.setData({pay_loading: true});
    app.alert('正在加载...', 'loading', '45%', 0);
    if (type === 1) {
      await insuraOrderPay(id, async (flag) => {
        await this.setData({pay_loading: false});
        flag && this.dataSource(1);
      });
    } else if (type === 2) {
      await getInsuranceOrgOrderPay(id, async (flag) => {
        await this.setData({pay_loading: false});
        flag && this.dataSource(1);
      });
    }
    app.alertDestroy();
  };
  /**
   * 查看发票
   * @param id
   * @returns {Promise<void>}
   */
  handleSeeInvoice = async (id) => {
    const data = await getInsuranceOrgInvoice(id);
    if (data && data.url) {
      window.open(data.url, '_blank');
    }
  };

  render() {
    let {total, page, data_loading, dataList, upload_visible} = this.state;
    return (
      <div className="insure-list-page">
        <div className="ilp-body">
          <div className="il-title">
            <span>我的保险订单</span>
            <span style={{marginLeft: 20, fontSize: 14}}><Icon type="info-circle"/> 订单状态更新可能出现延迟，如出现未更新请尝试 </span>
            <Button size="small" type="primary" onClick={() => this.dataSource(1)}>刷新订单</Button>
          </div>
          <div className="il-data">
            <Spin spinning={data_loading} tip="正在加载">
              {
                dataList.length ? dataList.map(order => {
                  let btns = [];
                  if (order.flag === '1') {
                    if (order.type === 1) {
                      btns.push(
                        <Button style={{marginLeft: 6}} size="small" href={app.urlGet(api.DownloadInsurance, {
                          id: order.id,
                          token: app.getToken(),
                          indexno: app.getData('indexno'),
                          account: app.getData('account'),
                        })}>下载保单</Button>
                      );
                      if (order.is_invoice === '1') {
                        btns.push(
                          <Button style={{marginLeft: 6}} size="small"
                                  onClick={() => this.handleSeeInvoice(order.id)}>查看发票</Button>
                        );
                      }
                    }
                  } else if (order.flag === '3') {
                    btns.push(
                      <Button style={{marginLeft: 6}} size="small" type="primary"
                              onClick={() => this.handleOrderPay(order.id, order.type)}>立即支付</Button>
                    );
                  }
                  if (order.type === 1) {
                    return (
                      <div className="ld-item" key={order.id}>
                        <Row type="flex" justify="space-between" align="middle">
                          <div className="di-name">{order.name} <span className="di-company">【{order.company}】</span>
                          </div>
                          <div>
                            <span className="di-amount">{order.amount}元</span>
                            <span>{order.flag === '2' || order.flag === '4' ? order.flag_title : order.pay_state_title}</span>
                          </div>
                        </Row>
                        <Row gutter={10}>
                          <Col span={8}>
                            <div className="di-item">保险类型：{order.type_title}</div>
                            <div className="di-item">保险单号：{order.cntr_no}</div>
                            <div className="di-item">保险有效期：{order.start_date} ~ {order.end_date}</div>
                          </Col>
                          <Col span={8}>
                            <div className="di-item">被保人：{order.ipsn_name}</div>
                            <div className="di-item">手机号：{order.mobile}</div>
                            <div className="di-item">邮箱：{order.email || '-'}</div>
                          </Col>
                          <Col span={8}>
                            <div className="di-btns" style={{marginTop: 60}}>{btns}</div>
                          </Col>
                        </Row>
                      </div>
                    );
                  } else if (order.type === 2) {
                    return (
                      <div className="ld-item" key={order.id}>
                        <Row type="flex" justify="space-between" align="middle">
                          <div className="di-name">{order.name} <span className="di-company">【{order.company}】</span>
                          </div>
                          <div>
                            <span className="di-amount">{order.amount}元</span>
                            <span>{order.flag === '2' || order.flag === '4' ? order.flag_title : order.pay_state_title}</span>
                          </div>
                        </Row>
                        <Row gutter={10}>
                          <Col span={8}>
                            <div className="di-item">保险类型：{order.type_title}</div>
                            <div className="di-item">保险方案：{order.scheme_name}</div>
                            <div className="di-item">保险单号：{order.cntr_no}</div>
                            <div className="di-item">保险有效期：{order.start_date} ~ {order.end_date}</div>
                            <div className="di-item">电子发票：{order.is_invoice === '1' ? order.taxpayer_no : '无'}</div>
                          </Col>
                          <Col span={8}>
                            <div className="di-item">姓名/公司名：{order.ipsn_name}</div>
                            <div className="di-item">手机号：{order.mobile}</div>
                            <div className="di-item">邮箱：{order.email || '-'}</div>
                            <div className="di-item">是否负责人：{order.is_head === '1' ? '是' : '否'}</div>
                            <div className="di-item">承保人数：{order.num}</div>
                          </Col>
                          <Col span={8}>
                            <div className="di-btns" style={{marginTop: 120}}>{btns}</div>
                          </Col>
                        </Row>
                      </div>
                    );
                  }
                }) : (<div className="null-data">暂无数据</div>)
              }
              <div style={{textAlign: 'right', padding: '20px 0'}}>
                <Pagination current={page} total={total} pageSize={20} showTotal={(t) => `共${t}条.`} size="small" onChange={this.dataSource}/>
              </div>
            </Spin>
          </div>
          {/*<Table*/}
          {/*  columns={columns}*/}
          {/*  dataSource={dataList}*/}
          {/*  size="small"*/}
          {/*  bordered*/}
          {/*  loading={data_loading}*/}
          {/*  locale={app.tbLocale(data_loading)}*/}
          {/*  className="mp-table table-odd-even-row"*/}
          {/*  pagination={{*/}
          {/*    current: page,*/}
          {/*    total: total,*/}
          {/*    pageSize: 20,*/}
          {/*    showTotal: (t) => `总共${t}条.`,*/}
          {/*    onChange: this.dataSource*/}
          {/*  }}*/}
          {/*/>*/}
        </div>
        <Drawer
          title="上传保险"
          placement="right"
          onClose={() => this.setData({upload_visible: false})}
          visible={upload_visible}
          width={700}
          maskClosable={false}
          getContainer={false}
          bodyStyle={{overflowY: 'auto', height: 'calc(100% - 55px)', padding: 15}}
        >
          <IUpload onCancel={() => this.setData({upload_visible: false})}/>
        </Drawer>
      </div>
    );
  }
}

export default IOrderList;



// WEBPACK FOOTER //
// ./src/routes/insure/IOrderList.jsx